<div class="box overflow-hidden h-full flex flex-col">
    <div class="box-header justify-between">
        <div class="box-title">
            Processos recentes
        </div>
    </div>
    <div class="box-body !p-0 flex-1 flex flex-col">
        <!-- Loading State -->
        <div *ngIf="loading" class="flex items-center justify-center p-8">
            <app-loading-spinner message="Carregando processos..."></app-loading-spinner>
        </div>

        <!-- Error State -->
        <div *ngIf="error && !loading" class="flex items-center justify-center p-8">
            <div class="text-center text-danger">
                <div class="flex items-center gap-2 mb-4">
                    <i class="ri-error-warning-line text-xl"></i>
                    <p class="!mt-1">Erro ao carregar processos recentes</p>
                </div>
                <button class="ti-btn ti-btn-primary-full !py-1 !px-2 ti-btn-wave" (click)="loadRecentProcesses()">
                    <i class="ri-refresh-line"></i>
                    Tentar Novamente
                </button>
            </div>
        </div>

        <!-- Processes List - Mostra apenas os 5 processos mais recentes -->
        <ul *ngIf="!loading && !error && recentProcesses.length > 0" class="list-group list-group-flush flex-1 flex flex-col justify-between">
            <li *ngFor="let process of recentProcesses" class="list-group-item !border-0 flex-1 flex items-center">
                <a class="flex items-center w-full hover:opacity-90 transition-opacity"
                    [routerLink]="['/admin/groups/list']"
                    [queryParams]="{ process_id: process.id, page: 1, per_page: 12 }">
                    <div class="me-2 leading-none">
                        <span
                            class="!text-primary inline-flex items-center justify-center avatar avatar-md avatar-rounded bg-primary/10">
                            {{ process.name | initials }}
                        </span>
                    </div>
                    <div class="flex-grow">
                        <p class="mb-0 font-semibold">{{ process.name | truncate:40 }}</p>
                        <p class="text-[0.75rem] text-[#8c9097] dark:text-white/50 mb-0">{{ process.protocol }}</p>
                    </div>
                    <div class="text-end">
                        <p class="mb-1 text-[0.75rem]">
                            {{ process.answers.label || '0/0' }} respostas
                        </p>
                        <span [class]="getStatusClass(process.status)">{{ process.status }}</span>
                    </div>
                </a>
            </li>
        </ul>

        <!-- Empty State -->
        <div *ngIf="!loading && !error && recentProcesses.length === 0" class="flex-1 flex items-center justify-center p-8">
            <div class="text-center text-gray-500">
                <i class="bi bi-inbox text-4xl mb-3 block"></i>
                <p class="font-semibold text-sm mb-1">Nenhum processo encontrado</p>
                <p class="text-xs">Não há processos para exibir.</p>
            </div>
        </div>
    </div>
</div>